import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { OneTrustProvider } from '../context/provider.js';
import { OneTrustScript } from '../script/script.js';

const withOneTrust = ({ performanceCookies, ...rest } = {})=>(Component)=>{
        const OneTrustHOC = ()=>{
            if (rest.oneTrustToken == null) {
                console.warn('[OneTrust HOC] Missing token');
                return null;
            }
            return jsxs(Fragment, {
                children: [
                    jsx(OneTrustScript, {
                        ...rest
                    }),
                    jsx(OneTrustProvider, {
                        performanceCookies: performanceCookies,
                        children: jsx(Component, {})
                    })
                ]
            });
        };
        OneTrustHOC.displayName = 'OneTrustHOC';
        return OneTrustHOC;
    };

export { withOneTrust };
//# sourceMappingURL=hoc.js.map
